module.exports = __webpack_public_path__ + "static/media/amigoo_paw.c740e0b1.svg";